import { useForm, UseFormProps, FormProvider, useWatch } from 'react-hook-form';
import { FormLabelErrorMessage } from '@/components/forms';
import FormCommentFooter from './FormCommentFooter';
import FormCommentHeader from './FormCommentHeader';
import { DEFAULT_FORM_CONFIG } from '@/constants';
import FormCommentBody from './FormCommentBody';
import { ReactNode } from 'react';
import { TFormData } from '.';

type TProps = {
  onSubmit: (comment: string) => Promise<void>;
  description?: ReactNode;
  comment?: string;
  title?: string;
  rows?: number;
};

const VARIABLES = {
  formConfig: {
    ...DEFAULT_FORM_CONFIG,
    defaultValues: {
      comment: ''
    }
  } as UseFormProps<TFormData>
};

const FormComment = ({ onSubmit, description, comment = '', title = 'Commentaire', rows = 3 }: TProps) => {

  const formMethods = useForm<TFormData>({ ...VARIABLES.formConfig, values: { comment } });
  const errorMessage = useWatch({ control: formMethods.control, name: 'errorMessage' });

  return (
    <FormProvider {...formMethods}>
      <FormCommentHeader title={title} description={description} />
      <FormCommentBody rows={rows} />
      <FormLabelErrorMessage errorMessage={errorMessage} />
      <FormCommentFooter onSubmit={onSubmit} />
    </FormProvider>
  );

};

export default FormComment;
